import { useEffect, useState } from 'react';

// Track an element's client size, falling back to window resize when
// ResizeObserver is unavailable.
export default function useWrapSize(ref, enabled = true) {
  const [size, setSize] = useState({ w: 0, h: 0 });

  useEffect(() => {
    if (!enabled) return undefined;
    const el = ref.current;
    if (!el) return undefined;
    const update = () => setSize({ w: el.clientWidth, h: el.clientHeight });
    update();
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', update);
      return () => window.removeEventListener('resize', update);
    }
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, [ref, enabled]);

  return size;
}
